export const EVALUATOR = '/evaluator';

export const ACCREDITATIONREVIEW = '/accreditationreview';

export const EVALUATOR_MAINTENANCE = '/evaluator/maintenance';

export const SCOPES = '/scopes';

export const DOCUMENTARY_EVALUATION = '/evaluator/documentaryEvaluation';

export const PENDING_ASSIGNMENTS = '/evaluator/pendingAssignments';

export const CORRECTIVE_ACTIONS = '/evaluator/documentaryEvaluation/correctiveActions';

export const EVALUATION_PLAN = '/evaluator/evaluationPlan';

export const TECHNICAL_REVIEWER = '/technicalReviewer';

export const TECHNICAL_ANALYSIS_REPORT = '/accreditationtechnical';

export const DECISION_EVALUATION = '/evaluator/decision/closureFindingsDecision';